<template>
  <router-view></router-view>
</template>

<script>
  export default {};
</script>

<style>
  @font-face {
    font-family: "Cygre";
    src: url("./assets/fonts/Cygre-Regular.woff") format("woff");
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: "Cygre";
    src: url("./assets/fonts/Cygre-Medium.woff") format("woff");
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: "Cygre";
    src: url("./assets/fonts/Cygre-Bold.woff") format("woff");
    font-weight: 700;
    font-style: normal;
  }
  *:not(i) {
    font-family: "Cygre" !important;
  }
  .small-text {
    font-size: 10px;
  }
  .small-text-days {
    font-size: 12px;
  }
  .bold {
    font-weight: 600;
  }
  .vue-notifyjs {
    z-index: 999999 !important;
    position: fixed !important;
  }
  .pointer {
    cursor: pointer;
  }
  .card.no-border-card {
    border-radius: 25px !important;
  }
  .g-sidenav-hidden .separador-secao {
    display: none;
  }
  button {
    border-radius: 30px !important;
  }
  h2.numberResult {
    font-size: 60px;
    color: #373737;
    font-weight: 400 !important;
  }
  h2.numberResult.write {
    font-size: 35px;
  }
  .header-body h6 {
    color: #373737 !important;
  }
  .card-body {
    padding: 2.3rem 3rem;
  }
  .btn-neutral:active,
  .btn-neutral:focus {
    background: white !important;
  }
  .modal-altura-fixa {
    max-height: 90vh;
  }

  .modal-body-scrollable {
    max-height: 75vh;
    overflow-y: auto;
    padding-right: 10px; /* evitar scroll colado à borda */
  }
  .bg-gray {
    background: #f2eff2 !important;
  }
  .relative {
    position: relative !important;
  }
  .n-br {
    border-radius: 0px !important;
  }
  header:not(.modal-content header) {
    padding: 0px !important;
    border-radius: 25px !important;
  }
  header button {
    border-radius: 25px !important;
  }
  .drawer .card {
    border-radius: 25px;
  }
  .b-form-date-controls button.btn.btn-outline-danger.btn-sm {
    color: #ff825d;
    border-color: #ff825d;
  }
  .text-500 {
    font-weight: 500 !important;
  }
  .underline {
    text-decoration: underline;
  }
  a.nav-link {
    margin: 3px 14px;
    padding: 10px 14px !important;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    color: #525f7f;
    transition: background 0.15s ease, color 0.15s ease;
  }
  a.nav-link.active {
    background: #fff0ec;
    color: #ff825d;
    font-weight: 600;
    border-radius: 8px;
  }
  a.nav-link:not(.active):hover {
    background: #f6f8fa !important;
    color: #ff825d !important;
  }

  .card h3,
  .medium-text,
  h5.h3 {
    color: #6e6e6e;
  }
  .gray-text {
    color: #6e6e6e !important;
  }
  .action-text.gray-text:hover {
    color: #ff825d !important;
  }

  .separador-secao h3 {
    color: #b0bac8;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.9px;
    text-transform: uppercase;
    line-height: 1;
    margin-bottom: 4px !important;
    padding: 0 1.5rem;
  }
  .separador-secao {
    padding: 22px 0 8px;
    border-top: 1px solid #efefef;
  }
  .nbt {
    border-top: 0px !important;
    padding-top: 14px !important;
  }

  /* Logout sempre no fundo */
  .sidebar-logout {
    flex-shrink: 0;
    padding: 16px 0 20px;
    border-top: 1px solid #efefef;
  }
  .logout-link {
    margin: 2px 14px !important;
    padding: 10px 14px !important;
    border-radius: 8px !important;
    font-size: 0.875rem !important;
    font-weight: 500 !important;
    color: #adb5bd !important;
    display: block;
  }
  .logout-link:hover {
    background: #fff5f5 !important;
    color: #f5365c !important;
  }
  .no-margin fieldset {
    margin-bottom: 0px !important;
  }
  .fs-26 {
    font-size: 26px;
  }
  .jc-fe {
    justify-content: flex-end;
  }
  @media (min-width: 1199px) {
    nav {
      display: none !important;
    }
  }
  .br-25 {
    border-radius: 25px;
  }
  small {
    font-size: 65% !important;
  }
  .hidden {
    visibility: hidden !important;
  }
  .alert {
    z-index: 999999 !important;
  }
  .transparent {
    background: transparent !important;
    border: none !important;
  }
  @media (max-width: 768px) {
    .card-body {
      padding: 25px !important;
    }
  }
  .pe-kpi.pe-kpi--orange .pe-kpi-label,
  .pe-kpi.pe-kpi--dark .pe-kpi-label {
    color: #fff !important;
  }
  .vi-kpi-card--orange .vi-kpi-label,
  .vi-kpi-card--dark .vi-kpi-label {
    color: #fff !important;
  }
  .swal2-cancel {
    border: 1px solid #ff825d !important;
    color: #ff825d !important;
    background: transparent !important;
  }
  .swal2-confirm {
    border: none !important;
  }
  .swal2-confirm:focus {
    box-shadow: none !important;
  }
</style>
